import { useQuery } from 'react-query';
import { getMldDealStatus } from 'modules/api';
import { log } from 'modules/api/afyLogger/afyLogger';

type MldDealStatus = {
  status: 'Active' | 'Trialing' | 'Cancelled';
  trialEndDate: string | null;
  trialStartDate: string | null;
  dealId: string;
};

type UseMldDealStatusReturn = {
  status: 'Active' | 'Trialing' | 'Cancelled' | undefined;
  trialEndDate: string | null | undefined;
  trialStartDate: string | null | undefined;
  dealId: string | undefined;
  isTrialing: boolean;
  isCancelled: boolean;
  isActive: boolean;
  isLoading: boolean;
  error: unknown;
};

export const useMldDealStatus = (): UseMldDealStatusReturn => {
  const { data, isLoading, error } = useQuery<MldDealStatus>(
    ['mldDealStatus'],
    getMldDealStatus,
    {
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      onSuccess: () => {
        log('MLD deal status fetched successfully', 'useMldDealStatus', ['mld-deal']);
      },
      onError: () => {
        log('Error fetching MLD deal status', 'useMldDealStatus', ['mld-deal']);
      },
    }
  );

  return {
    status: data?.status,
    trialEndDate: data?.trialEndDate,
    trialStartDate: data?.trialStartDate,
    dealId: data?.dealId,
    isTrialing: data?.status === 'Trialing',
    isCancelled: data?.status === 'Cancelled',
    isActive: data?.status === 'Active',
    isLoading,
    error,
  };
};
